import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '@/pages/auth';

export const Route = createFileRoute('/_guest/reset-password')({
  component: ResetPasswordPage,
});
